import { render, staticRenderFns } from "./FoodType.vue?vue&type=template&id=4c73b8f4&scoped=true&"
import script from "./FoodType.vue?vue&type=script&lang=js&"
export * from "./FoodType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73b8f4",
  null
  
)

export default component.exports